import dayjs from 'dayjs';

export const now = dayjs().format('YYYY-MM-DD');

export const formatDate = (date: string | Date) => dayjs(date).format('DD.MM.YYYY');
